var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userInfo.firm_type == 1)?_c('supplier-goods'):_vm._e(),(_vm.userInfo.firm_type == 2)?_c('purchaser-shops'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }